module.exports = __webpack_public_path__ + "static/media/award3@2x.380b9260.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/award3@2x.png
// module id = 1126
// module chunks = 0